/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/label-has-associated-control */

// @mui material components
import Card from "@mui/material/Card";
// import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import "react-dropdown/style.css";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import {
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  IconButton,
  Button,
  InputAdornment,
} from "@mui/material";
// import { AccessAlarm, ThreeDRotation } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { useTranslation } from "react-i18next";
import AlertDialog from "./dialog_success";
import DeleteUser from "./delete_user";

function AddPost() {
  const [file, setFile] = useState();
  const [files1, setFiles1] = useState([]);

  const [files, setFiles] = useState([]);
  function handleChange(e) {
    const fies = Array(e.target.files.length).fill("");

    setFiles(fies.map((item, index) => URL.createObjectURL(e.target.files[index])));
    setFiles1(fies.map((item, index) => e.target.files[index]));
    setFile(e.target.files[0]);
  }

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [name, setName] = useState();
  return (
    <DashboardLayout>
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <Card>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SuiTypography variant="h6">New Post</SuiTypography>
            </SuiBox>
            <div style={{ width: "400px", margin: "20px" }}>
              <div className="form-group  col-md-12 ">
                <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                  body
                </label>
                <textarea
                  id="freeform"
                  name="freeform"
                  rows="4"
                  cols="50"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                >
                  Enter your description here
                </textarea>
              </div>
              {/* <img src={file} /> */}
              <div className="form-group  col-md-12">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Add Image
                </label>
                <input
                  required
                  id="name"
                  type="file"
                  multiple
                  className="form-control"
                  name="name"
                  onChange={handleChange}
                />
              </div>
              <div className="form-group  col-md-12" style={{ marginTop: "20px" }}>
                {files.map((item) => (
                  <img src={item} style={{ width: "1000px" }} />
                ))}
              </div>

              <AlertDialog body1={name} images1={files1} />
            </div>
          </Card>
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddPost;
